import React from 'react';
import ListItem from '@smart-tv/components/list';
import { FocusHandler } from '@noriginmedia/norigin-spatial-navigation';
import { storeNetworkSpeed } from '@smart-tv/utils/network-speed';

// Thresholds based on streaming requirements: 25 Mbps = 4K, 15 = HD, 5 = SD
function networkRating(mbps: number): string {
  if (mbps >= 25) return 'Excellent (4K)';
  if (mbps >= 15) return 'Good (HD)';
  if (mbps >= 5) return 'Fair (SD)';
  return 'Poor';
}

interface Props {
  listItemClassName?: string;
  onFocus?: FocusHandler;
}

const NetworkSpeedBenchmark: React.FC<Props> = ({ listItemClassName, onFocus }) => {
  const [result, setResult] = React.useState<string>('Press to run');
  const [running, setRunning] = React.useState(false);

  const runBenchmark = React.useCallback(async () => {
    if (running) return;
    setRunning(true);
    setResult('Running…');

    const measurement = await storeNetworkSpeed();

    if (measurement) {
      const mbps = measurement.bps / 1_000_000;
      setResult(`${mbps.toFixed(2)} Mbps — ${networkRating(mbps)}`);
    } else {
      setResult('Error – check network');
    }

    setRunning(false);
  }, [running]);

  return (
    <ListItem
      listItemProps={{ className: listItemClassName }}
      onEnterPress={runBenchmark}
      onFocus={onFocus}
      data={['Network Speed', result]}
    />
  );
};

export default NetworkSpeedBenchmark;
